export enum RouteNames {
  AUTHORIZATION = '/',
  PROFILE = '/profile',
  REFERAL_MANAGEMENT = '/referal-management',
}
